import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';

interface ProfileProps {
  name: string;
  title: string;
  photo?: string;
  practiceAreas?: string[];
  email?: string;
  phone?: string;
  slug?: string;
}

const Profile: React.FC<ProfileProps> = ({
  name,
  title,
  photo,
  practiceAreas,
  email,
  phone,
  slug
}) => (
  <Card variant="profile">
    {/* Photo */}
    {photo ? (
      <img
        src={photo}
        alt={`Portrett av ${name}`}
        className="w-48 h-48 rounded-full mx-auto mb-6 object-cover border-4 border-gray-200"
      />
    ) : (
      <div className="w-48 h-48 rounded-full mx-auto mb-6 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
        <svg className="w-24 h-24 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
      </div>
    )}

    {/* Name */}
    <h3 className="text-2xl font-bold text-gray-900 mb-2 font-serif">{name}</h3>

    {/* Title */}
    <p className="text-lg text-accent mb-4">{title}</p>

    {/* Practice Areas */}
    {practiceAreas && practiceAreas.length > 0 && (
      <div className="mb-4 text-left w-full">
        <p className="font-semibold text-gray-700 mb-2">Fagområder:</p>
        <ul className="text-gray-600 space-y-1">
          {practiceAreas.map((area, idx) => (
            <li key={idx}>{area}</li>
          ))}
        </ul>
      </div>
    )}

    {/* Contact Info */}
    <div className="text-left w-full mb-6 space-y-2">
      {email && (
        <p className="text-gray-700">
          <a href={`mailto:${email}`} className="text-accent hover:underline">
            {email}
          </a>
        </p>
      )}
      {phone && (
        <p className="text-gray-700">
          <a href={`tel:${phone}`} className="text-accent hover:underline">
            {phone}
          </a>
        </p>
      )}
    </div>

    {/* Read More Button */}
    {slug && (
      <Link
        to={`/om-oss/${slug}`}
        className="inline-block bg-accent text-white px-6 py-3 rounded-md hover:bg-accent-dark transition-colors duration-200"
      >
        Les mer
      </Link>
    )}
  </Card>
);

export default Profile;

